import { gql } from '@grandvisionhq/graphql';

var StoreFragment = gql`
  fragment Store on Store {
    code
    slug
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    name
    shortName
    email
    phone
    storenote
    servicesNotAvailable
    distance
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    accessibility
    hearingAppointmentPossible
    wheelchairAccessible
    weekendOpen
    storeTypes
    appointmentsAvailable
  }
`;

export { StoreFragment as default };
//# sourceMappingURL=store.js.map
